import React from 'react';

export const Checkbox = ({ value, rules, ...rest }) => {
  return (
    <input type="checkbox" className="Form__Checkbox" value={value} {...rest}/>
  )
}

